export const WarningIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.16699 10.4993C2.16699 5.90018 5.90033 2.16602 10.5003 2.16602C15.1087 2.16602 18.8337 5.90018 18.8337 10.4993C18.8337 15.1002 15.1087 18.8327 10.5003 18.8327C5.90033 18.8327 2.16699 15.1002 2.16699 10.4993ZM9.76699 7.34102C9.76699 6.94185 10.1003 6.60768 10.5003 6.60768C10.9003 6.60768 11.2253 6.94185 11.2253 7.34102V11.0243C11.2253 11.4252 10.9003 11.7493 10.5003 11.7493C10.1003 11.7493 9.76699 11.4252 9.76699 11.0243V7.34102ZM10.5087 14.4002C10.1003 14.4002 9.77533 14.0668 9.77533 13.6668C9.77533 13.2668 10.1003 12.9418 10.5003 12.9418C10.9087 12.9418 11.2337 13.2668 11.2337 13.6668C11.2337 14.0668 10.9087 14.4002 10.5087 14.4002Z"
      fill="#FF6961"
    />
  </svg>
)
